"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const popover_1 = require("../styles/popover");
const hooks_1 = require("../utils/hooks");
const mixpanel_1 = require("../utils/mixpanel");
const Empty = () => {
    const { i18n } = (0, hooks_1.useTranslate)();
    (0, hooks_1.useViewTrackEvent)(mixpanel_1.EmptyCartRender);
    return ((0, jsx_runtime_1.jsxs)(popover_1.PopoverEmpty, { "data-empty-cart": true, children: [(0, jsx_runtime_1.jsx)(popover_1.Title, { children: i18n('cart.empty.title') }), (0, jsx_runtime_1.jsx)(popover_1.EmptyText, { children: i18n('cart.empty.text') })] }));
};
exports.default = Empty;
